import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {Button} from '@components/common/base/buttons'
import {Popup} from '@components/common/base/popup'
import {ProjectsTree} from '@components/common/projects-tree/projects-tree'
import {crmStore} from '@components/crm/crm-store'
import {LinkButtonAdd} from '../../link-button-add'
import {getTreeHeight} from '../get-tree-height'
import {useStore} from '../subtasks-store'

export const AddExistingOneAsSubtask = observer(() => {
  const [state, store] = useStore()

  useEffect(() => {
    const height = getTreeHeight()

    store.setTreeHeight(state.showSubtasksTree ? height : 0)
  }, [state.showSubtasksTree, state.addSubtaskShown])

  if (!store.task) {
    return null
  }

  const footer = state.showSubtasksTree ? (
    <div className="flex justify-end gap-12">
      <Button color="secondary" onClick={() => store.cancel()}>
        {Lang.msg.cancel}
      </Button>
      <Button onClick={() => store.saveSelectedTasks()}>
        {Lang.msg.subtask.save}
      </Button>
    </div>
  ) : null

  const close = () => {
    store.setAddSubtaskShown(false)
    store.setShowTree(false)
  }

  return (
    <>
      <LinkButtonAdd
        text={Lang.msg.subtask.addExistingOneAsSubtask}
        onMouseDown={() => {
          store.setAddSubtaskShown(true)
          store.setShowTree(true)
        }}
        type={'add-as-subtask'}
      />

      {state.addSubtaskShown && (
        <Popup
          title={Lang.msg.subtask.creatingSubtask}
          width={400}
          close={close}
          autoHeight
          footer={footer}
          popupInWnd
        >
          {state.showSubtasksTree && (
            <ProjectsTree
              onClose={close}
              value={state.selectedSubtasks}
              filterTasks={t => t.id !== store.task.id && !crmStore.isDeal(t)}
              filterProjects={p => !crmStore.isCrmProject(p)}
              treeStyle={{height: state.treeHeight}}
              onChange={x => store.setSelectedTasks(x)}
            />
          )}
        </Popup>
      )}
    </>
  )
})
